export const CATEGORIES = {
  preco: { label: "Preço / Orçamento", short: "Preço", color: "#10B981", bg: "rgba(16,185,129,0.12)" },
  tempo: { label: "Tempo / Prioridade", short: "Tempo", color: "#F59E0B", bg: "rgba(245,158,11,0.12)" },
  concorrencia: { label: "Concorrência / Solução Atual", short: "Concorrência", color: "#F97316", bg: "rgba(249,115,22,0.12)" },
  autoridade: { label: "Autoridade / Decisor", short: "Autoridade", color: "#3B82F6", bg: "rgba(59,130,246,0.12)" },
  ceticismo: { label: "Ceticismo / Risco", short: "Ceticismo", color: "#EF4444", bg: "rgba(239,68,68,0.12)" },
};

export const CATEGORY_KEYS = Object.keys(CATEGORIES);

export function catMeta(key) {
  return CATEGORIES[key] || CATEGORIES.ceticismo;
}
